
<template>
      <div
        class="progress-bar pb-1"
        :class="getColor()"
        role="progressbar"
        :style="
          'padding-top:4px;width:' + getPercentageStyle(quantity,total) +
          '%;'
        "
      >
        <small class="ml-2">
          {{title}}
          <span class="">
              {{quantity}} of {{total}}
          </span>

          ({{ getPercentage(quantity,total) }}%)
          
        </small>
      </div>
</template>

<script>

export default {

  props: {
    total:false,
    quantity: false,
    title:false,
    color:false,
    percentage:false
  },
  data() {
    return {

    };
  },
  methods: {
      getColor() {
        if(this.color){
         return this.color
        }
        let percentage = this.getPercentage(this.quantity,this.total)
        if (percentage == 0) {
          return "bg-secondary";
        }
        if (percentage > 90) {
          return "bg-danger";
        }
        if (percentage > 60) {
          return "bg-warning";
        }
        return "bg-success";
      },
      getPercentage(available,total){
        if (available == null) {
          available = 0;
        }
        if (total == null) {
          total = 0;
        }
        if (available == 0 && total == 0) {
          return 0;
        }
        return Math.round((available * 100) / total,2);
      },
      getPercentageStyle(available,total){
        if(this.percentage){
          return this.percentage
        }
        if (available == null) {
          available = 0;
        }
        if (total == null) {
          total = 0;
        }
        if (available == 0 && total == 0) {
          return 0;
        }
        return Math.round((available * 100) / total,2);
      }
  },
};
</script>
